import React from 'react';
import { IconDownload } from '@tabler/icons-react';
import { Box, Button } from '@mantine/core';
import { PopupEventVendorDetailsUpcoming } from '../types';

type PopupUpcomingDownloadProps = {
  event: PopupEventVendorDetailsUpcoming;
};

const PopupUpcomingDownload: React.FC<PopupUpcomingDownloadProps> = ({ event }) => {
  const href = event.eventLocation?.location.siteDirectionsDocUrl ?? '';

  return (
    <Box p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Button
        component={href ? 'a' : 'button'}
        target="_blank"
        rel="noopener noreferrer"
        href={href}
        variant="white"
        disabled={!href}
        leftSection={<IconDownload />}
      >
        Site Directions (PDF)
      </Button>
    </Box>
  );
};

export default PopupUpcomingDownload;
